// extracted by mini-css-extract-plugin
export var backdropBlur = "_ig-0";
export var contentCard = "_ig-5";
export var frame = "_ig-2";
export var image = "_ig-4";
export var imagePane = "_ig-3";
export var modal = "_ig-1";